import React from 'react';
import { View, TouchableOpacity, ViewPropTypes, Platform, Dimensions } from 'react-native'

import { isEmpty as _isEmpty, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { Images } from '../../../Themes';
import AddCard from '../AddCard';
import PaymentCard from '../PaymentCard';
import PaymentCardList from '../PaymentCardList';

import styles from './PaymentMethod.Styles';

import { Fonts } from '../../../../../../App/Themes';

const renderExtraCard = (renderExtraCardProp, isCardListOpend, isEmptyCardsList) => {
  if ((!isCardListOpend && !isEmptyCardsList) || !_isFunction(renderExtraCardProp)) {
    return null;
  }

  return (
    <View style={styles.addCardContainer}>
      {renderExtraCardProp({
        isCardListOpend,
        isEmptyCardsList,
      })}
    </View>
  );
};

const PaymentMethod = ({
  titleAndIconContainerStyle,
  title,
  titleStyle,
  icon,
  iconStyle,
  paymentMethodAccessibilityLabel,
  paymentEditIconAccessibilityLabel,
  defaultPayment,
  paymentCards,
  onAddCard,
  onOpenCardList,
  isCardListOpend,
  onSelectDefaultCard,
  renderExtraCard: renderExtraCardProp,
  theme,
  isValidTopupNumber,
  ...props
}) => {
  const isEmptyCardsList = _isEmpty(paymentCards);
  return (
    <View style={styles.footerBorder(theme)}>
      <View style={styles.widthAdjustment}>
        <View style={[styles.paymentMethod, titleAndIconContainerStyle]}>
          <VFText
            style={[styles.titleStyle, titleStyle, {
              color: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? theme.colors.textColorTwo : theme.colors.textColorThree,
              fontFamily: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? Fonts.type.VFFont : Fonts.type.VodafoneLt,
              fontSize: 26,
            }]}
            i18nKey={title}
            testKey={paymentMethodAccessibilityLabel}
            type="primary"
          />
          {!isCardListOpend && !isEmptyCardsList && (
            <TouchableOpacity onPress={onOpenCardList}>
              <View style={styles.editView}>
                <VFText
                  i18nKey="top_up_quick_action_edit"
                  style={[styles.edit]}
                  testKey={FrameworkTestKeys.TopUpPaymentEditBtn}
                />
                <Icon
                  name={icon}
                  type="image"
                  accessibilityLabel={paymentEditIconAccessibilityLabel}
                  style={[styles.iconImage, iconStyle]}
                />
              </View>
            </TouchableOpacity>
          )}
        </View>
        {isCardListOpend ? (
          <PaymentCardList
            defaultPayment={defaultPayment}
            cards={paymentCards}
            onAddCard={onAddCard}
            onSelectDefaultCard={onSelectDefaultCard}
          />
        ) : isEmptyCardsList ? (
          <AddCard
            text="top_up_quick_action_add_payment_method_item_text"
            onPress={onAddCard}
            // containerStyle={styles.addCardContainer}
            isValidTopupNumber={isValidTopupNumber}
            containerStyle={{ ...styles.addCardContainer, height: 130 }}
          />
        ) : (
          <View style={styles.paymentMethodContentContainer}>
            {isCardListOpend ? (
              <PaymentCardList
                defaultPayment={defaultPayment}
                cards={paymentCards}
                onAddCard={onAddCard}
                onSelectDefaultCard={onSelectDefaultCard}
                renderExtraCard={renderExtraCard(
                  renderExtraCardProp,
                  isCardListOpend,
                  isEmptyCardsList,
                )}
              />
            ) : isEmptyCardsList ? (
              <>
                <AddCard
                  text="top_up_quick_action_add_payment_method_item_text"
                  onPress={onAddCard}
                  isValidTopupNumber={isValidTopupNumber}
                />
                {renderExtraCard(renderExtraCardProp, isCardListOpend, isEmptyCardsList)}
              </>
            ) : (
              <PaymentCard {...defaultPayment} isDefault />
            )}
          </View>
        )}
      </View>
    </View>
  );
};

PaymentMethod.defaultProps = {
  title: 'top_up_quick_action_payment_method_title',
  icon: Images.edit_pen,
  theme: LightThemeColors,
};

PaymentMethod.propTypes = {
  titleAndIconContainerStyle: ViewPropTypes.style,
  title: PropTypes.string,
  titleStyle: ViewPropTypes.style,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconStyle: ViewPropTypes.style,
  paymentMethodAccessibilityLabel: PropTypes.string,
  paymentEditIconAccessibilityLabel: PropTypes.string,
  defaultPayment: PropTypes.object,
  paymentCards: PropTypes.array,
  onAddCard: PropTypes.func,
  onOpenCardList: PropTypes.func,
  onSelectDefaultCard: PropTypes.func,
  isCardListOpend: PropTypes.bool,
  renderExtraCard: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export { renderExtraCard };
export default withTheme(PaymentMethod);
